import { SingleSelectDropdownItem } from 'Angular/features/components/dropdowns/single-select-dropdown/interfaces/single-select-dropdown-item.interface';

export const CURRENCY_NONE = null;

// Currency choices where selecting none is allowed
export const OPTIONAL_CURRENCY_OPTIONS: SingleSelectDropdownItem[] = [
    { label: 'None', value: CURRENCY_NONE },
    { label: 'US Dollar (USD)', selectedLabel: 'USD', value: 'USD' },
    { label: 'Canadian Dollar (CAD)', selectedLabel: 'CAD', value: 'CAD' },
    { label: 'Euro (EUR)', selectedLabel: 'EUR', value: 'EUR' },
    { label: 'British Pound (GBP)', selectedLabel: 'GBP', value: 'GBP' },
    { label: '────────────────────────', type: 'divider', disabled: true },
    { label: 'UAE Dirham (AED)', selectedLabel: 'AED', value: 'AED' },
    { label: 'Australian Dollar (AUD)', selectedLabel: 'AUD', value: 'AUD' },
    { label: 'Bos. Mark (BAM)', selectedLabel: 'BAM', value: 'BAM' },
    { label: 'Brazilian Real (BRL)', selectedLabel: 'BRL', value: 'BRL' },
    { label: 'Swiss Franc (CHF)', selectedLabel: 'CHF', value: 'CHF' },
    { label: 'Chinese Yuan (Offshore) (CNH)', selectedLabel: 'CNH', value: 'CNH' },
    { label: 'Chinese Yuan (Onshore) (CNY)', selectedLabel: 'CNY', value: 'CNY' },
    { label: 'Czech Koruna (CZK)', selectedLabel: 'CZK', value: 'CZK' },
    { label: 'Danish Krone (DKK)', selectedLabel: 'DKK', value: 'DKK' },
    { label: 'British Pence (GBX)', selectedLabel: 'GBX', value: 'GBX' },
    { label: 'Hong Kong Dollar (HKD)', selectedLabel: 'HKD', value: 'HKD' },
    { label: 'Hungarian Forint (HUF)', selectedLabel: 'HUF', value: 'HUF' },
    { label: 'Israeli Shekel (ILS)', selectedLabel: 'ILS', value: 'ILS' },
    { label: 'Icelandic Króna (ISK)', selectedLabel: 'ISK', value: 'ISK' },
    { label: 'Japanese Yen (JPY)', selectedLabel: 'JPY', value: 'JPY' },
    { label: 'Mexican Peso (MXN)', selectedLabel: 'MXN', value: 'MXN' },
    { label: 'Norwegian Krone (NOK)', selectedLabel: 'NOK', value: 'NOK' },
    { label: 'New Zealand Dollar (NZD)', selectedLabel: 'NZD', value: 'NZD' },
    { label: 'Polish Złoty (PLN)', selectedLabel: 'PLN', value: 'PLN' },
    { label: 'Romanian Leu (RON)', selectedLabel: 'RON', value: 'RON' },
    { label: 'Russian Ruble (RUB)', selectedLabel: 'RUB', value: 'RUB' },
    { label: 'Swedish Krona (SEK)', selectedLabel: 'SEK', value: 'SEK' },
    { label: 'Singapore Dollar (SGD)', selectedLabel: 'SGD', value: 'SGD' },
    { label: 'South African Rand (ZAR)', selectedLabel: 'ZAR', value: 'ZAR' },
];

// Currency choices where one must be selected
export const CURRENCY_OPTIONS: SingleSelectDropdownItem[] = OPTIONAL_CURRENCY_OPTIONS.filter(
    (option) => option.type === 'divider' || option.value !== CURRENCY_NONE
);
